module.exports = __webpack_public_path__ + "img/waze.7aabf2dd.png";